import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './CommentsForm.jsx'

export default createSubmit(name)